<span [class]="getStatusClass()">{{ getStatusDisplay() }}</span>
<span *ngIf="invoiceId !== null" style="white-space: nowrap;">
  (Ref {{ invoiceId }})
</span>
